import { View } from "react-native-ui-lib";
import React from "react";
import {
  LocalSettingsContext,
  useLocalSettings,
} from "../../utilities/local-settings";

export interface LocalSettingsControllerProps {
  children: React.ReactNode;
}

export const LocalSettingsController = ({
  children,
}: LocalSettingsControllerProps) => {
  const localSettings = useLocalSettings();

  if (false === localSettings.bootstraped) {
    return <View />;
  }

  return (
    <LocalSettingsContext.Provider value={localSettings}>
      {children}
    </LocalSettingsContext.Provider>
  );
};
